import axios from "axios";

import Config from "../../config";

const actionEditarAgendamento = (agendamentoId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/agendamentos/${agendamentoId}/editar`,
        data
    });
};

export default actionEditarAgendamento;
